import { Link } from 'wouter';
import type { ReactNode } from 'react';
import { ArrowRight } from '@phosphor-icons/react';

interface Props {
  href: string;
  children: ReactNode;
  external?: boolean;
}

export function GuideAction({ href, children, external }: Props) {
  const className =
    'inline-flex items-center gap-1.5 rounded-lg border border-white/10 bg-white/5 px-3 py-1.5 text-xs font-medium text-white transition hover:border-neurax-electric/40 hover:bg-neurax-electric/10';

  if (external) {
    return (
      <a href={href} target="_blank" rel="noreferrer" className={className}>
        {children}
        <ArrowRight className="h-3 w-3" />
      </a>
    );
  }

  return (
    <Link href={href} className={className}>
      {children}
      <ArrowRight className="h-3 w-3" />
    </Link>
  );
}
